import React from 'react'
import { FormGroup } from "react-bootstrap"
import { PropTypes } from 'prop-types'
import { red } from '../../../utils/constants'

const ErrorList = ({ errors,offset }) => {

    const coloffset = offset != undefined ? offset: ''
    const spanClassName = `col-sm-12 ${coloffset}`
    const ulClassName   = `col-sm-12 ${coloffset}`

    return (
        <FormGroup  style={{ color:red }}>
            <span className={spanClassName}>Please correct the following:</span><br/><br/>
            <ul className={ulClassName} style={{ paddingLeft:'40px', marginTop:'-15px' }}>
            { errors.map((error,index) =>{
                return (<li key={index}>{error}</li>)                                             
                })
            }
            </ul> 
        </FormGroup>   
    )
}
ErrorList.propTypes = {
    errors: PropTypes.array,
    offset:PropTypes.string
}
export default ErrorList


// WEBPACK FOOTER //
// ./src/containers/season/components/ErrorList.js